var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar",class:("navbar--" + (_vm.$store.state.navbarClassStyle))},[_c('ComNavbar',{staticClass:"pc",attrs:{"mode":"default"}}),_c('MobNavbar',{staticClass:"mb"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }